// src/components/store/sections/faqs/FaqV61CardgridLimeZest.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV61CardgridLimeZest(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={61}
      archKey="card_grid"
      archLabel="Support Help Cards"
      palName="LimeZest"
      grad="from-lime-500 via-green-500 to-emerald-700"
      lightBg="bg-lime-50"
      textCol="text-lime-800"
      borderCol="border-lime-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#84cc16"
      {...props}
    />
  );
}
